import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.aside`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: flex;
    flex-direction: column;
    gap: ${space['space-800']};
    width: 500px;
    flex-shrink: 0;
  }
`;

export const Title = styled.h2`
  font-family: ${fonts.body};
  font-size: ${primitives.typography['scale-text']['scale-text-800']};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.tight};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const Card = styled.nav`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const NavItem = styled.button<{ $active?: boolean; $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${space['space-500']};
  width: 100%;
  padding: ${space['space-500']};
  background: ${({ $active }) => ($active ? semantic.bg.surfaceSubtle : 'transparent')};
  border: ${size.stroke['stroke-default']} solid
    ${({ $active }) => ($active ? 'transparent' : semantic.border.default)};
  border-radius: ${size.radius['radius-lg']};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  color: ${({ $disabled }) => ($disabled ? semantic.text.tertiary : semantic.text.primary)};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  text-align: left;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${({ $disabled }) => ($disabled ? 'transparent' : semantic.bg.surfaceSubtle)};
    border-color: transparent;
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }

  &:disabled {
    pointer-events: none;
  }
`;

export const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
`;

export const SignOutWrapper = styled.div`
  padding-left: ${space['space-200']};
`;
